import service from '@/utils/server';
let modelPath = '/mytask/mytask';
let modelName = 'log/logDashboardDetail'
export const queryList = data => {
    return service({
        url: modelPath+'/pageInfo',
        method: 'post'
    })
};

export const addLog = data => {
  return service({
    url: modelName+'/add',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/sso/ssoError/api/index.js